import React, { useEffect, useMemo, useState } from "react";
import "./settingsModal.css";

const clamp01 = (n) => Math.max(0, Math.min(1, Number(n) || 0));

export default function SettingsModal({
  open,
  onClose,

  bgmAudio,
  sfxAudio,

  musicEnabled,
  setMusicEnabled,
  sfxEnabled,
  setSfxEnabled,
  musicVolume,
  setMusicVolume,
  sfxVolume,
  setSfxVolume,

  onHelp,
  onPrivacy,
  onTerms,
}) {
  


  // apply volumes live
  useEffect(() => {
    if (!bgmAudio) return;
    bgmAudio.volume = clamp01(musicVolume);
    bgmAudio.muted = !musicEnabled;
  }, [bgmAudio, musicVolume, musicEnabled]);

  useEffect(() => {
    if (!sfxAudio) return;
    sfxAudio.volume = clamp01(sfxVolume);
    sfxAudio.muted = !sfxEnabled;
  }, [sfxAudio, sfxVolume, sfxEnabled]);

  const openExternal = (url) => {
  if (window.Telegram?.WebApp?.openLink) {
    window.Telegram.WebApp.openLink(url);
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

const openTelegramChat = () => {
  const url = "https://t.me/taptopia_io";

  if (window.Telegram?.WebApp?.openTelegramLink) {
    window.Telegram.WebApp.openTelegramLink(url);
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};


  if (!open) return null;

  return (
    <div className="modal_box">

    <div className="modal_title" style={{ position: "relative" }}>
  Settings
  <button
    type="button"
    className="modal_close"
    onClick={onClose}
  />
</div>

      <div className="modal_body modal_body_3">

      
        {/* SOUND SECTION */}
        <div className="set-section">

          {/* MUSIC */}
          <div className="set-audio-block">
            <div className="set-audio-head">
              <div className="shadow2 set-audio-name" style={{fontWeight: 600, color: "#fff", fontSize: 21}}>Sound</div>
              <label className="set-switch">
                <input
                  type="checkbox"
                  checked={musicEnabled}
                  onChange={(e) => setMusicEnabled(e.target.checked)}
                />
                <span className="set-slider" />
              </label>
            </div>

            <div className="set-range-row">
              <span className="set-icon" aria-hidden><img
  src={musicEnabled ? "/v2/sound_on.png" : "/v2/sound_off.png"}
  alt="Music" style={{height: 32}}
/>
</span>
              <input
  className="set-range"
  type="range"
  min="0"
  max="100"
  value={Math.round(clamp01(musicVolume) * 100)}
  onChange={(e) => setMusicVolume(clamp01(Number(e.target.value) / 100))}
  style={{
    background: `linear-gradient(
      to right,
      #f6cf35 0%,
      #f4c737 ${Math.round(clamp01(musicVolume) * 100)}%,
      #532102 ${Math.round(clamp01(musicVolume) * 100)}%,
      #532102 100%
    )`,
  }}
/>

            </div>
          </div>

          {/* SFX */}
          <div className="set-audio-block">
            <div className="set-audio-head">
              <div className="shadow2 set-audio-name" style={{fontWeight: 600, color: "#fff", fontSize: 21}}>SFX</div>
              <label className="set-switch">
                <input
                  type="checkbox"
                  checked={sfxEnabled}
                  onChange={(e) => setSfxEnabled(e.target.checked)}
                />
                <span className="set-slider" />
              </label>
            </div>

            <div className="set-range-row">
              <span className="set-icon" aria-hidden><img
  src={sfxEnabled ? "/v2/sound_on.png" : "/v2/sound_off.png"}
  alt="SFX" style={{height: 32}}
/>
</span>
             <input
  className="set-range"
  type="range"
  min="0"
  max="100"
  value={Math.round(clamp01(sfxVolume) * 100)}
  onChange={(e) => setSfxVolume(clamp01(Number(e.target.value) / 100))}
  style={{
    background: `linear-gradient(
      to right,
      #f6cf35 0%,
      #f4c737 ${Math.round(clamp01(sfxVolume) * 100)}%,
      #532102 ${Math.round(clamp01(sfxVolume) * 100)}%,
      #532102 100%
    )`,
  }}
/>
            </div>
          </div>
        </div>



        {/* ACTION BUTTONS */}
        <div style={{padding: 10}}>

          <li style={{color: "#fff", display: "block"}}
  onClick={openTelegramChat}
>
  <b
    style={{
      float: 'left',
      width: '48px',
      height: '48px',
      display: 'inline-block',
      backgroundImage: "url('/v2/menu_7.png')",
      backgroundSize: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    }}
  />
  Help And Support
</li>

<li style={{color: "#fff",  display: "block"}}
  onClick={() => openExternal("https://taptopia.io/privacy.html")}
>
  <b
    style={{
      float: 'left',
      width: '48px',
      height: '48px',
      display: 'inline-block',
      backgroundImage: "url('/v2/menu_10.png')",
      backgroundSize: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    }}
  />
  Privacy And Policy
</li>

<li style={{color: "#fff", display: "block"}}
  onClick={() => openExternal("https://taptopia.io/terms.html")}
>
  <b
    style={{
      float: 'left',
      width: '48px',
      height: '48px',
      display: 'inline-block',
      backgroundImage: "url('/v2/menu_2.png')",
      backgroundSize: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    }}
  />
  Terms Of Service
</li>


          
        </div>

        <div style={{textAlign: "center", float: "left", width: "100%", marginTop: 15,marginBottom: 15}}>
                <a href="#"><img src="./discord.png" style={{display:'none', width: '36px', height: '28px', marginLeft: 12, marginRight: 12}} alt="Discord" /></a>
                <a href="https://t.me/taptopia_io" target="_new"><img src="./v2/telegram.png" style={{ width: '28px', height: '28px', marginLeft: 12, marginRight: 12}} alt="Telegram" /></a>
                <a href="https://x.com/taptopia_io" target="_new"><img src="./v2/x.png" style={{ width: '28px', height: '28px', marginLeft: 12, marginRight: 12}} alt="X" /></a>
                </div>

        

      </div>

    </div>
  );
}
